<template>
    <div class="flex align-items-center justify-content-end pagination-wrap" v-bind="$attrs">
        <div class="pagination-inner-wrap">
            <span class="mr--35 text--sm">{{ paginationData.currentPage }} - {{ paginationData.totalPages }} of {{ paginationData.total }}</span>
            <nav aria-label="Page navigation example">
                <ul class="pagination__list mb--0">
                    <li class="pagination__item" :class="{ 'disabled': isFirstPage }" @click="changePaginationNum(1)">
                        <span class="pagination__link" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                        </span>
                    </li>
                    <li v-for="idx in paginationData.totalPages" :key="idx" class="pagination__item" :class="{ 'active': checkActivePage(idx) }">
                        <span class="pagination__link" @click="changePaginationNum(idx)">
                            {{ idx }}
                        </span>
                    </li>
                    <li class="pagination__item" :class="{ 'disabled': isLastPage }" @click="changePaginationNum(paginationData.totalPages)">
                        <a class="pagination__link" href="#" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { formatCount, serilaizeQuery } from "@/utils/helpers";

export default {
    name: "Pagination",

    props: {
        paginationData: {
            type: Object,
            default: () => {},
        },
        routeChange: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        isFirstPage(){
            return Number(this.paginationData.currentPage) === 1;
        },

        isLastPage(){
            return Number(this.paginationData.currentPage) === this.paginationData.totalPages;
        },
    },

    methods: {
        formatCount,
        serilaizeQuery,

        changePaginationNum(page) {            
            this.$emit("pageChange", page);
            
            if (this.routeChange) {
                const pageObject = {
                    ...this.$route.query,
                    page: page ? page : this.paginationData.currentPage,
                };
    
                const currentRoute = this.$route.path;
                const queryParam = this.serilaizeQuery(pageObject);
                        
                this.$router.replace(`${currentRoute}?${queryParam}`);
            }
        },

        checkActivePage(page) {            
            return page === Number(this.paginationData.currentPage);
        },
    },
};
</script>